import { Injectable, SkipSelf } from '@angular/core';
import { Constants } from 'src/app/middleware/common/reusableclassesAndFunctions/constants';
import { EnvService } from 'src/app/env.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiEndPointsTask } from '../common/apiUrls/api-end-points-task';
@Injectable({
  providedIn: 'root',
})
export class TaskService {
  private baseUrl: any;
  private baseUrlTrans: any;
  private baseUrlRole: any;
  private isProjectExtended:boolean;
  private baseUrlTask:any;
  private baseURlOrg:any;
  private baseURlSetting:any;
  headers={
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
}
  constructor(
    private _http: HttpClient,
    private apiAddress: ApiEndPointsTask,
    public env: EnvService,
    private constant: Constants
  ) {
    this.isProjectExtended=false;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrl = this.constant.ManageContactsportNumber;
    else
      this.baseUrl = this.env.apiUrl + this.constant.ManageContactsportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlTrans = this.constant.ManageTranscationportNumber;
    else
      this.baseUrlTrans =
        this.env.apiUrl + this.constant.ManageTranscationportNumber;
    if (this.env.apiUrl == undefined || this.env.apiUrl == '')
      this.baseUrlRole = this.constant.RolePortNumber;
    else this.baseUrlRole = this.env.apiUrl + this.constant.RolePortNumber;
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseUrlTask = this.constant.ManageTask;
else
    this.baseUrlTask = this.env.apiUrl+this.constant.ManageTask;
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
    this.baseURlOrg = this.constant.ManageOrganizationPortNumber;
else
    this.baseURlOrg = this.env.apiUrl+this.constant.ManageOrganizationPortNumber;
    if( this.env.apiUrl==undefined  || this.env.apiUrl=='')
      this.baseURlSetting = this.constant.SettingsPortNumber;
  else
      this.baseURlSetting = this.env.apiUrl+this.constant.SettingsPortNumber;
    
  }


  
  addTask(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.addTask;  
    return this._http.post(apiURL, reqModel).pipe();
  } 
     
  getTaskList(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskList;  
    return this._http.post(apiURL, reqModel).pipe();
  } 
  UpdateTaskStatus(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.UpdateTaskStatus;  
    return this._http.post(apiURL, reqModel).pipe();
  } 
  getTaskDetailByID(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskDetailByID;  
    return this._http.post(apiURL, reqModel).pipe();
  } 

  getSubTasks(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.getSubTasks;  
    return this._http.post(apiURL, reqModel).pipe();
  } 

  removeSubTasks(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.removeSubTasks;  
    return this._http.post(apiURL, reqModel).pipe();
  }

  removeTasks(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.removeTasks;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  archivedTask(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.archivedTask;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  addTasklistFolder(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.addTasklistFolder;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getTaskListFolders(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskListFolders;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  addTaskList(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.addTaskList;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getTaskLists(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskLists;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  renameTasklistFolder(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.renameTasklistFolder;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  removeTasklistFolder(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.removeTasklistFolder;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  renameTasklist(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.renameTasklist;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  removeTasklist(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.removeTasklist;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  archivedTaskList(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.archivedTaskList;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getTaskByTaskList(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskByTaskList;  
    return this._http.post(apiURL,reqModel).pipe();
  }
  GetTaskGroupsByTaskList(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.GetTaskGroupsByTaskList;  
    return this._http.post(apiURL,reqModel).pipe();
  }
  reorderTasksLists(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.reorderTaskList;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  reorderTaskGroup(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.reorderTaskGroup;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  taskMovetoTaskList(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.taskMovetoTaskList;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  taskStatus(reqModel): Observable<any> {      
    const apiURL = this.baseURlOrg + this.apiAddress.taskStatus;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  addTaskTemplate(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.addTaskTemplate;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  updateTaskTemplateTasks(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.updateTaskTemplate;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getTaskTemplates(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getTaskTemplates;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getActiveTaskTemplateCategories(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getActiveTaskTemplateCategories;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getSharedAccessRoles(reqModel): Observable<any> {
    const apiURL = this.baseUrlRole + this.apiAddress.getSharedAccesslRoles;
    return this._http.post(apiURL, reqModel).pipe();
  }

  shareTaskListFolder(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.shareTaskListFolder;
    return this._http.post(apiURL, reqModel).pipe();
  }
  

  getTasklistFolderSharedWithMe(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.getTasklistFolderSharedWithMe;
    return this._http.post(apiURL, reqModel).pipe();
  }

  addEditTaskGroup(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.addEditTaskGroup;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  removeTaskGroup(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.removeTaskGroup;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  SendManualTaskReminderService(reqModel): Observable<any> {
    const apiURL = this.baseUrlTask + this.apiAddress.sendManualReminderforTask;
    return this._http.post(apiURL, reqModel).pipe();
  }

  getSingleTaskTemplates(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getSingleTaskTemplates;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  importTaskFromTemplate(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.importTaskFromTemplate;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  addSingleTaskTemplate(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.addSingleTaskTemplate;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getArchivedTaskLists(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getArchivedTaskLists;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getArchivedSingleTaskLists(reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getArchivedSingleTaskLists;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  makeTaskRequired(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.makeTaskRequired;  
    return this._http.post(apiURL, reqModel).pipe();
  } 

  triggerTaskGroup(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.triggerTaskGroup;  
    return this._http.post(apiURL, reqModel).pipe();
  } 

  changeGroupType(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.changeGroupType;  
    return this._http.post(apiURL, reqModel).pipe();
  } 

  makeTaskExternal(reqModel): Observable<any> {         
    const apiURL = this.baseUrlTask + this.apiAddress.makeTaskExternal;  
    return this._http.post(apiURL, reqModel).pipe();
  } 

  getAllSubFoldersForFolder(reqModel): Observable<any> {         
    const apiURL = this.baseURlSetting + this.apiAddress.getAllSubFoldersForFolder;  
    return this._http.post(apiURL, reqModel).pipe();
  } 

  getTasklistInternalUrl (reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getTasklistInternalUrl;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  resendTasklistURL (reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.resendTasklistURL;  
    return this._http.post(apiURL,reqModel).pipe();
  }

  getTasklistFolderSharedRoles (reqModel): Observable<any> {      
    const apiURL = this.baseUrlTask + this.apiAddress.getTasklistFolderSharedRoles;  
    return this._http.post(apiURL,reqModel).pipe();
  }
}
